

define(['angular', 'squid/index', 'xo-beaver/dist/logger'], function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('fi.messages', ['squid']).factory('$fiMessages', function ($renderContent, $logger) {

        function getContentKeys(hasFi) {
            if (hasFi) {
                return {
                    member: 'payment.processorDeclineMember',
                    generic: 'payment.processorDeclineMemberGeneric',
                    buyerCredit: 'payment.processorDeclineMemberBuyerCredit'
                };
            } else {
                return {
                    member: 'payment.processorDeclineMemberNoFI',
                    generic: 'payment.processorDeclineMemberNoFIGeneric',
                    buyerCredit: 'payment.processorDeclineMemberBuyerCreditNoFI'
                };
            }
        }

        function processorDeclinedMsg(checkoutSession, hasFi) {
            var declinedInstruments = checkoutSession.get('declinedInstruments');

            if (angular.isArray(declinedInstruments) && declinedInstruments.length) {
                var msg;
                var type = 'warning';
                var instrument = declinedInstruments[0];
                var contentKeys = getContentKeys(hasFi);

                if (instrument.type === 'PAYMENT_CARD') {
                    if (instrument.card_type && instrument.last4) {
                        $logger.info('processor_decline', { hasFi: hasFi, message: 'member' });

                        msg = $renderContent(contentKeys.member, {
                            type: instrument.card_type,
                            number: instrument.last4
                        });
                    } else {
                        $logger.info('processor_decline', { hasFi: hasFi, message: 'generic' });

                        msg = $renderContent(contentKeys.generic);
                    }
                } else {
                    $logger.info('processor_decline', { hasFi: hasFi, message: 'buyerCredit' });

                    msg = $renderContent(contentKeys.buyerCredit);
                }

                checkoutSession.set('declinedInstruments', null);
                return {
                    type: type,
                    msg: msg
                };
            }
        }

        function errorMsg(isGambling) {
            var msg;
            if (isGambling) {
                msg = $renderContent('creditcard.noEligibleFI');
            } else {
                msg = $renderContent('creditcard.noFIContingency');
            }
            return {
                type: 'error',
                msg: msg
            };
        }

        return {
            processorDeclinedMsg: processorDeclinedMsg,
            errorMsg: errorMsg
        };
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-models/src/fi/lib/fiMessages.js
 ** module id = 379
 ** module chunks = 1
 **/